import { Avatar, Badge, Typography } from "@mui/material";
import React from "react";
import { formatMessageTime } from "../../utils/helpers";

const SideChatMessage = ({ sender, message, unread, latestMessageTime, setUser, chat }) => {
  const fullName = sender.first_name + ' ' + (sender.last_name || '');

  return (
    <div className="flex justify-between px-2 py-2 gap-1 items-center hover:bg-gray-300 hover:rounded-md cursor-pointer" onClick={() => setUser({
      full_name: fullName,
      profile_picture: sender.profile_picture,
      last_seen: latestMessageTime,
      firebase_thread_id: chat?.firebase_thread_id,
      chat_id: chat?.id,
      ...sender // in case we need other user object fields
    })}>
      <Avatar alt={fullName} src={sender.profile_picture} />
      <div className="flex flex-col gap-1 flex-1">
        <Typography>{fullName}</Typography>
        <Typography className="truncate w-64">{message}</Typography>
      </div>
      <div className="flex flex-col gap-1 px-2 items-end justify-start">
        <Typography color="primary">{formatMessageTime(latestMessageTime)}</Typography>
        {unread > 0 && (

          <div className="rounded-full bg-blue-500 w-5 h-5 flex items-center justify-center">
            <Typography className="p-2" color="textSecondary">{unread}</Typography>
          </div>
        )}

        {/* <Badge color="primary" badgeContent={unread} max={999} /> */}

      </div>
    </div>
  );
};

export default SideChatMessage;
